import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EmailFooter } from 'src/app/models/email-footer';
import { CkeditorUploadService } from 'src/app/services/ckeditor-upload.service';

@Component({
  selector: 'wm-email-footer-content-editor',
  templateUrl: './email-footer-content-editor.component.html',
  styleUrl: './email-footer-content-editor.component.css',
  standalone: false
})
export class EmailFooterContentEditorComponent implements OnInit, OnDestroy {
  @ViewChild('htmlContentEditor', { static: false }) htmlContentEditor: CKEditorComponent;

  @Input() emailFooterId: string;
  @Input() emailFooterHtmlContent: string;
  @Input() form: UntypedFormGroup;

  @Output() contentEdited: EventEmitter<string> = new EventEmitter();

  public Editor = ClassicEditor;
  public editorConfig = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      '|',
      'bulletedList',
      'numberedList',
      'imageUpload',
      '|',
      'undo',
      'redo'
    ]
  };

  constructor (
    private _fb: UntypedFormBuilder,
    private _uploadAdapter: CkeditorUploadService
  ) { }

  ngOnInit() {
    this.form.addControl('htmlContent', this._fb.control('', [Validators.required]));

    this.form.controls['htmlContent'].valueChanges.subscribe(value => {
      this.contentEdited.emit(value);
    });
  }

  ngOnDestroy() {
    this.form.removeControl('htmlContent');
  }

  public editorReady(editor) {
    const parentId: string = this.emailFooterId;
    editor.plugins.get('FileRepository').createUploadAdapter = loader => {
      this._uploadAdapter.setLoader(loader, parentId);

      this._uploadAdapter.loader = loader;

      this._uploadAdapter.isUploading.subscribe((isUploading: boolean) => {
        if (this.form.controls['htmlContent-IS_UPLOADING']) {
          this.form.controls['$htmlContent-IS_UPLOADING'].setValue(
            isUploading ? 1 : 0
          );
        }
      });

      return this._uploadAdapter;
    };
  }
}
